import { IWithChildren } from '@/util/reactTypes';

// Sidebar holds a fixed 300px on desktop (lg+) and stacks below the
// main column on mobile. The previous max-xl:w-40 step collapsed the
// rail to 160px between lg (1024px) and xl (1280px), which made the
// webcam thumbnail and ad slot unreadably narrow — drop that step
// so 300px holds across all desktop widths.
const sideClass = [
  'w-[300px] ml-[30px] flex-shrink-0',
  'max-lg:w-auto max-lg:min-w-0 max-lg:ml-0',
  '[&>article:not(:last-child)]:mb-4',
].join(' ');

export function Side({
  children,
}: { } & IWithChildren) {
  return (
    <aside className={sideClass}>
      {children}
    </aside>
  );
}
